import { NotificationsScreen } from './NotificationsBell';

export default function NotificationsScreenEntry(): JSX.Element {
  return <NotificationsScreen />;
}
